
import {authorize} from "../helper/authorize-token";
import superagent from "superagent";
import {GetDevice, ORIENTATION} from "../../lib/constants";

const APP_IS_LOADING = "APP_IS_LOADING";
const APP_GET_CONFIG = "APP_GET_CONFIG";
const APP_SET_WLF = "APP_SET_WLF";
const APP_SET_CONFIG = "APP_SET_CONFIG";
const APP_SET_RESOLUTION = "APP_SET_RESOLUTION";
const APP_SET_ORIENTATION = "APP_SET_ORIENTATION";
const APP_SET_DEMO_MODE = "APP_SET_DEMO_MODE";
const APP_SET_PARENT_WINDOW = "APP_SET_PARENT_WINDOW";
const APP_TOGGLE_HYPERVERGE = "APP_TOGGLE_HYPERVERGE";
const APP_SET_WLF_AUM = "APP_SET_WLF_AUM";

const setParentWindow = (has_parent) => {
  return dispatch => {
    dispatch({
      type: APP_SET_PARENT_WINDOW,
      hasParentWindow: has_parent,
    });
  }
}

const setWlfAUM = (aum) => {
  return dispatch => {
    dispatch({
      type: APP_SET_WLF_AUM,
      aum,
    })
  }
}

const toggleHyperverge = () => {
  return dispatch => {
    dispatch({
      type: APP_TOGGLE_HYPERVERGE,
    })
  }
}

/**
 * Superagent plugin for showing and hiding the loading spinner.
 */
const handleLoading = (dispatch, disable) => {

  if (!disable) {
    dispatch({
      type: APP_IS_LOADING,
      isLoading: true,
    });
  }

  return req => {

    const callback = req.callback;
    req.callback = (err, res) => {
      if (!disable) {
        dispatch({
          type: APP_IS_LOADING,
          isLoading: false,
        });
      }
      callback.call(req, err, res);
    }
  }
};

const appSetWlf = wlf => {
  return dispatch => {
    dispatch({
      type: APP_SET_WLF,
      wlf: wlf,
    });
  }
};

const appSetDemoMode = val => {
  return dispatch => {
    dispatch({
      type: APP_SET_DEMO_MODE,
      value: val,
    })
  }
}

/**
 * @param source {string} filename
 * @param event {UserEvents}
 * @param detail {any}
 */
const logUserEvent = (source, event, detail) => {
  return new Promise((resolve) => {
    return superagent.agent()
      .post("/api/log-user-event")
      .send({ source, event, detail })
      .then(resolve)
      .catch(err => {
        console.log("Error", err);
        resolve();
      })
  })
}

const appIsLoading = isLoading => {
  return dispatch => {
    dispatch({
      type: APP_IS_LOADING,
      isLoading: isLoading,
    });
  }
};

const getConfig = () => {
  return (dispatch, getState) => {
    dispatch({
      type: APP_GET_CONFIG,
      payload: superagent
        .get("/api/config/get_sa_config")
        .use(authorize(getState()))
    });
  }
};

const setAppOrientation = orientation => {
  return dispatch => {
    dispatch({
      type: APP_SET_ORIENTATION,
      orientation,
    })
  }
}

const setAppResolution = (width, height) => {
  return dispatch => {
    dispatch({
      type: APP_SET_RESOLUTION,
      payload: {
        width,
        height,
        device: GetDevice(width),
      },
    })
  }
}

const appSetConfig = (config) => {
  return dispatch => {
    dispatch({
      type: APP_SET_CONFIG,
      payload: config,
    })
  }
};

const stateInit = {
  isLoading: false,
  config: null,
  hasParentWindow: false,
  kycOnboarding: false,
  orientation: ORIENTATION.PORTRAIT,
};

const appReducer = (state = stateInit, action) => {

  switch(action.type) {
    case APP_TOGGLE_HYPERVERGE:
      const new_state = {
        ...state,
      }
      new_state.kycOnboarding = !new_state.kycOnboarding;
      return new_state;
    case APP_IS_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case APP_SET_ORIENTATION:
      return {
        ...state,
        orientation: action.orientation,
      }
    case APP_SET_PARENT_WINDOW:
      return {
        ...state,
        hasParentWindow: action.hasParentWindow,
      }
    case APP_SET_RESOLUTION:
      return {
        ...state,
        ...action.payload,
      };
    case APP_SET_CONFIG:
      return {
        ...state,
        config: action.payload,
      };
    case APP_SET_DEMO_MODE:
      return {
        ...state,
        demo: action.value,
      }
    case APP_SET_WLF_AUM:
      const curr = { ...state };
      curr.wlf.AUM = action.aum;
      return curr;
    case APP_GET_CONFIG + "_FULFILLED":
      return {
        ...state,
        sa_config: action.payload.body.data.sa_config,
      };
    case APP_SET_WLF:
      return {
        ...state,
        wlf: action.wlf,
      };
    default:
      return state;
  }
};

export { appReducer, appIsLoading, APP_IS_LOADING,
  handleLoading, getConfig, appSetWlf, appSetConfig,
  setAppResolution, appSetDemoMode, setParentWindow,
  toggleHyperverge, setWlfAUM, logUserEvent,
  setAppOrientation };
